import React, { useState } from "react";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Button,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Icon from "../assets/images/Icon.png";
import "../assets/css/Home.css";

const MainPageBanner = (props) => {
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsDrawerOpen(open);
  };

  const menuItems = [
    { text: "Team Management", link: "/teams" },
    { text: "Features", link: "/features" },
    { text: "Pricing", link: "/pricing" },
    !props.data ? { text: "Login", link: "/login", button: true } : {},
    !props.data
      ? {
          text: "Sign Up",
          link: "/signup",
          button: true,
          color: "warning",
        }
      : {},
    props.data
      ? {
          text: "My Account",
          link: "/app/events",
          color: "primary",
          button: true,
        }
      : {},
  ];
  return (
    <div className="fixed">
      <div
        className="nav"
        style={{
          padding: "5px 0",
          minHeight: "87px",
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px"
        }}
      >
        <div
          className="subnav"
          style={{
            maxWidth:'none',
            minHeight: "100%",
            width: isSmallScreen ? "90%" : "80%",
          }}
        >
          <div
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center",
              gap: "2%",
              height: "100%",
              width:'100%'
            }}
          >
            <div style={{ flex: 1, justifyContent: "left", display: "flex" }}>
              <a href="/app/events">
                <img
                  alt="logo"
                  src={Icon}
                  width={150}
                  style={{ cursor: "pointer" }}
                />
              </a>
            </div>

            {isSmallScreen ? (
              <>
                <IconButton
                  style={{ width: 40, height: 40 }}
                  onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                >
                  <MenuIcon />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={isDrawerOpen}
                  onClose={toggleDrawer(false)}
                >
                  <List>
                    {menuItems.map((item) =>
                      item !== null && Object.keys(item).length ? (
                        <ListItem
                          button
                          component="a"
                          key={item?.text}
                          href={item?.link}
                        >
                          {item?.button ? (
                            <Button variant="contained" style={{background:'#d9bca9'}} color={item?.color}>
                              {item.text}
                            </Button>
                          ) : (
                            <ListItemText primary={item?.text} />
                          )}
                        </ListItem>
                      ) : (
                        ""
                      )
                    )}
                  </List>
                </Drawer>
              </>
            ) : (
              <>
                <div style={{ display: "flex", flex: 2 }}>
                  {menuItems.map((item) =>
                    !item?.button &&
                    item !== null &&
                    Object.keys(item).length ? (
                      <a
                        style={{
                          flex: item?.text.length,
                          display: "flex",
                          justifyContent: "center",
                          textDecoration: "none",
                          color: "black",
                          textAlign: "center",
                          minWidth: "80px",
                          cursor: "pointer",
                        }}
                        href={item?.link}
                        key={item?.text}
                      >
                        <div style={{ width: "100%" }}>
                          {item?.content ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  height: "30px",
                                  minWidth: "30px",
                                  borderRadius: "100%",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "tan",
                                }}
                              >
                                {item?.text[0]}
                              </div>
                              {item?.text}
                            </div>
                          ) : (
                            item?.text
                          )}
                        </div>
                      </a>
                    ) : (
                      ""
                    )
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "flex-end",
                    textDecoration: "none",
                    gap: "10%",
                  }}
                >
                  {props.data ? (
                    <Button variant="contained" href="/app/events" style={{background:'#d9bca9',maxWidth:'150px',justifyContent:'center'}}>
                      My Account
                    </Button>
                  ) : (
                    <>
                      <Button
                        style={{ maxHeight: "37px",justifyContent:'center',maxWidth:'80px',background:'#d9bca9' }}
                        variant="contained"
                        className="flex justify align"
                        href="/login"
                      >
                        Login
                      </Button>
                      <Button
                        style={{ maxHeight: "37px",maxWidth:'95px',justifyContent:'center !important',background:'#8e7c6f' }}
                        variant="contained"
                        color="warning"
                        className="flex justify align"
                        href="/signup"
                      >
                        Sign Up
                      </Button>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>{" "}
      <Divider style={{ opacity: "20%" }} />
    </div>
  );
};

export default MainPageBanner;
